import { actionType } from "../../constants/GeneralBarcodes";

const initialState = {
  pickedBinsPerGroupReport: {},
  isReportInProgress: false,
  error: null
};

export default (state = initialState, action) => {
  if (!action) return state;

  switch (action.type) {
    case actionType.GENERATE_PICKED_BINS_PER_GROUP_REPORT_START:
      return {
        ...state,
        isReportInProgress: true
      };
    case actionType.GENERATE_PICKED_BINS_PER_GROUP_REPORT:
      return {
        ...state,
        pickedBinsPerGroupReport: action.payload,
        isReportInProgress: false
      };
    case actionType.GENERATE_PICKED_BINS_PER_GROUP_REPORT_ERROR:
      return {
        ...state,
        isReportInProgress: false,
        error: action.payload
      };

    default:
      return state;
  }
};
